import { MenuItem, TextField } from '@mui/material';
import type { SerpMapView } from '../../../api/src/fakes/serp-appearance';
export function SerpMapViewSelect({
  value,
  disabled,
  onChange,
}: {
  value: SerpMapView;
  disabled?: boolean;
  onChange(view: SerpMapView): void;
}) {
  return (
    <TextField
      select
      label="Вид карты"
      value={value}
      disabled={disabled}
      onChange={(e) => onChange(e.target.value as SerpMapView)}
      sx={{ minWidth: 225 }}
    >
      <MenuItem value="bricks">Кирпичики</MenuItem>
      <MenuItem value="groups">Плитки по группам</MenuItem>
      <MenuItem value="queries">Запросы</MenuItem>
    </TextField>
  );
}
